import DashboardLayout from 'src/pages/Layout/DashboardLayout.vue';
import AuthLayout from 'src/pages/Authentication/AuthLayout.vue';
import WaiverLayout from "@/pages/Layout/WaiverLayout";
// GeneralViews
import NotFound from 'src/pages/GeneralViews/NotFoundPage.vue';
import Unauthorized from 'src/pages/GeneralViews/UnauthorizedPage'
// Pages load on demand, one chunk per menu, so a first visit downloads the
// shell plus the page opened rather than every page. Layouts and the general
// views stay eager because every route needs them.
const Unsubscribe = () =>
  import(/* webpackChunkName: "misc" */ 'src/pages/GeneralViews/Unsubscribe.vue');

//Authentication
const Login = () =>
  import(/* webpackChunkName: "pages" */ 'src/pages/Authentication/Login.vue');
const Register = () =>
  import(/* webpackChunkName: "pages" */ 'src/pages/Authentication/Register.vue');
const newOrExistingUser = () =>
  import(/* webpackChunkName: "account" */ 'src/pages/Authentication/NewOrExistingUser');

// Games
const PastGames = () =>
  import(/* webpackChunkName: "games" */ 'src/pages/Games/PastGames');
const PastGameDetails = () =>
  import(/* webpackChunkName: "games" */ '@/pages/Games/PastGameDetails');
const Leaderboard = () =>
  import(/* webpackChunkName: "games" */ '@/pages/Leaderboards/Leaderboard');


//Settings
const MyProfile = () =>
  import(/* webpackChunkName: "settings" */ 'src/pages/Settings/MyProfile');



// Checkin
const Checkin = () =>
  import(/* webpackChunkName: "checkin" */ 'src/pages/Checkin/Checkin');
const SelectCompany = () =>
  import(/* webpackChunkName: "checkin" */ '@/pages/Checkin/SelectCompany');
const FutureGames = () =>
  import(/* webpackChunkName: "checkin" */ '@/pages/Checkin/FutureGames');

//Photos
const MyPhotos = () =>
  import(/* webpackChunkName: "photos" */ '@/pages/Photos/MyPhotos');

//Bookings
const CreateBooking = () =>
  import(/* webpackChunkName: "booking" */ '@/pages/Bookings/CreateBooking');
const PaymentPage = () =>
  import(/* webpackChunkName: "booking" */ '@/pages/Bookings/PaymentPage');
const ShareableWaiver = () =>
  import(/* webpackChunkName: "checkin" */ '@/pages/Checkin/ShareableWaiver');
const Survey = () =>
  import(/* webpackChunkName: "surveys" */ '@/pages/Surveys/Survey');
const BookingReceipt = () =>
  import(/* webpackChunkName: "booking" */ '@/pages/Bookings/BookingReceipt');
const SearchableWaiver = () =>
  import(/* webpackChunkName: "checkin" */ '@/pages/Checkin/SearchableWaiver');

let authPages = {
  path: '/',
  component: AuthLayout,
  name: 'Authentication',
  children: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    }
  ]
};

let gamesMenu = {
  path: '/games',
  component: DashboardLayout,
  redirect: '/past-games',
  name: 'Games',
  meta: { requiresAuth: true },
  children: [
    {
      path: '/past-games',
      name: 'Past Games',
      component: PastGames,
    },
    {
      path: '/game-details',
      name: 'Game Details',
      component: PastGameDetails
    },
    {
      path: '/leaderboard',
      name: 'Leaderboard',
      component: Leaderboard,
    },
  ]
};

let checkinMenu = {
  path: '/checkin',
  component: DashboardLayout,
  redirect: '/checkin',
  name: 'Waiver',
  meta: { requiresAuth: true },
  children: [
    {
      path: '/checkin',
      name: 'Check In',
      component: SelectCompany,
    },
    {
      path: '/upcoming-games',
      name: 'Upcoming Games',
      component: FutureGames,
    },

  ]
};

let photosMenu = {
  path: '/photos',
  component: DashboardLayout,
  redirect: '/photos',
  name: 'Photos',
  meta: { requiresAuth: true },
  children: [
    {
      path: '/photos',
      name: 'My Photos',
      component: MyPhotos,
    },


  ]
};



let settingsMenu = {
  path: '/settings',
  component: DashboardLayout,
  redirect: '/settings/profile',
  name: 'Settings',
  meta: { requiresAuth: true },
  children: [
    {
      path: 'profile',
      name: 'My Profile',
      components: { default: MyProfile }
    }
  ]
};

const routes = [
  {
    path: '/',
    redirect: '/settings/profile',
    name: 'Home',
    meta: { requiresAuth: true }
  },
  {
    path: '/checkin/:company',
    name: 'Checkin',
    component: Checkin
  },
  {
    path: '/checkin/:company/lookup',
    name: 'Checkin-search',
    component: SearchableWaiver
  },
  {
    path: '/checkin/:company/kiosk',
    name: 'Checkin-kiosk',
    component: Checkin
  },
  {
    path: '/checkin/:company/walk-in',
    name: 'Checkin-walkin',
    component: Checkin
  },
  {
    path: '/waiver/:hash',
    name: 'Shareable Waiver',
    component: ShareableWaiver
  },
  {
    path: '/returning',
    name: 'New or Existing User',
    component: newOrExistingUser
  },
  {
    path: '/book/:company',
    name: 'Bookings',
    component: CreateBooking
  },
  {
    path: '/book/:company/:event',
    name: 'Bookings',
    component: CreateBooking
  },
  {
    path: '/receipt',
    name: 'Bookings',
    component: BookingReceipt
  },
  {
    path: '/pay/:hash',
    name: 'Payment',
    component: PaymentPage
  },
  {
    path: '/surveys/:hash',
    name: 'Survey',
    component: Survey
  },
  {
    path: '/unsubscribe',
    name: 'Unsubscribe',
    component: Unsubscribe
  },

  // dashboardMenu,
  gamesMenu,
  settingsMenu,
  photosMenu,
  checkinMenu,
  authPages,
  { path: '/forbidden', component: Unauthorized },
  { path: '*', component: NotFound }
];

export default routes;
